import { TimeManager } from '@app/hooks/use-time-manager';
import { CliqueiAcheiData, Restaurant } from '@app/types';
import { MenuItemWithDetailsOfBag } from '@app/types/menu-item';
import { TagManagerInstance } from '@app/utils/tag-manager';
import { createContext, useContext } from 'react';

type RestaurantContextData = {
  primaryColor: string;
  secondaryColor: string;
  setSelectedMenuItemOfBagForEdit: React.Dispatch<React.SetStateAction<MenuItemWithDetailsOfBag | null>>;
  cliqueiAcheiData: CliqueiAcheiData;
  restaurant: Restaurant;
  timeManager: TimeManager;
  isAInternalMenu: boolean;
  isOrderedOnRestaurant: boolean;
  isMenuOnlyView: boolean;
  isAInternalMenuOrOrderedOnRestaurant: boolean;
  onlyRegisterOrder: boolean;
  tagManager: TagManagerInstance | null;
};

export const RestaurantContext = createContext({} as RestaurantContextData);

export function useRestaurantContext() {
  return useContext(RestaurantContext);
}
